//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../../media/MediaQuery";

//css
import styled from "styled-components";

// img
import CloseSvg from "../../../assets/img/icon/icon_close.svg";
import PlusSvg from "../../../assets/img/icon/plus.svg";
import TotalSvg from "../../../assets/img/icon/total.svg";

// 임시 이미지
import Product from "../../../assets/img/picture/product_01.jpg";

// responsive
import { M, MMinus, MPlus, T } from "../../../utils/MT";

// componet
import BasicBtn from "../../../component/button/BasicBtn";
import CheckBox from "../../../component/button/CheckBox";
import PaymentInfo from "../../../component/content/PaymentInfo";
import AddressInfo from "../../../component/content/AddressInfo";

// 임시데이터
import { cartDataList } from "../../../Data";

export default function PayComplete() {
    //페이지 이동
    const navigate = useNavigate();
    const goProduct = () => {
        navigate(`/product`);
    };

    const goMyOrer = () => {
        navigate(`/mypage/myorder`);
    };

    const goDetailPage = (item) => {
        navigate(`/product/detail/` + item.id);
    };

    return (
        <Warp>
            <Title>ORDER COMPLETE</Title>
            <Desc>주문이 정상적으로 처리 되었습니다.</Desc>
            <OrderNum>
                주문하신 제품의 주문번호는<span>28000120222041</span>입니다.
            </OrderNum>

            {/* 주문상품리스트 */}

            <TableWrap>
                {/* 테이블 타이틀 */}
                <PC>
                    <TabelTitle>
                        <TableName>상품정보</TableName>
                        <TableDelivery>배송비</TableDelivery>
                        <TableNum>수량</TableNum>
                        <TablePrice>가격</TablePrice>
                    </TabelTitle>
                </PC>

                {/* 상품 리스트 */}
                <OrderListBigWrap>
                    {cartDataList.map((item, index) => {
                        return (
                            // 카트 리스트
                            <OrderListBox key={item.id}>
                                {/* 상품명 */}
                                <TableName>
                                    <DivListBox>
                                        <ImgWrap
                                            onClick={() => {
                                                goDetailPage();
                                            }}
                                        >
                                            <Img src={item.productImg} alt={item.itemName} />
                                        </ImgWrap>
                                        <TextWrap>
                                            <TopWrap>
                                                <Name
                                                    thinText={item.thinText}
                                                    onClick={() => {
                                                        goDetailPage();
                                                    }}
                                                >
                                                    {item.itemName}
                                                </Name>
                                            </TopWrap>

                                            <OptionWrap>
                                                <Option>{item.option}</Option>
                                            </OptionWrap>

                                            {/* Mobile - 총 수량 */}
                                            <Mobile>
                                                <UtilWrap>
                                                    {/* Mobile - 판매가 */}
                                                    <MbPriceWrap>
                                                        <MbPrice>{item.price}</MbPrice>
                                                        <MbWon>원</MbWon>
                                                    </MbPriceWrap>
                                                    <Slice>/</Slice>
                                                    <MbNum>수량 1 개</MbNum>
                                                </UtilWrap>
                                            </Mobile>
                                        </TextWrap>
                                    </DivListBox>
                                </TableName>
                                {/* 배송비 */}
                                <TableDelivery>
                                    <DelText>{item.delivery}</DelText> <DelWon>원</DelWon>
                                </TableDelivery>

                                {/* PC - 총 수량 */}
                                <PC>
                                    <TableNum>
                                        <Num>1</Num>
                                    </TableNum>
                                </PC>

                                {/* 판매가 */}
                                <TablePrice>
                                    <PriceBigWrap>
                                        <PriceWrap>
                                            <Price>{item.price}</Price>
                                            <Won>원</Won>
                                        </PriceWrap>
                                        <p>할인 : {item.discount} 원</p>
                                    </PriceBigWrap>
                                </TablePrice>
                            </OrderListBox>
                        );
                    })}
                </OrderListBigWrap>
            </TableWrap>

            {/* 결제 정보 */}
            <PaymentInfo />

            {/* 배송지 정보 */}
            <AddressInfo />

            <BtnWrap>
                <BasicBtn
                    onClick={() => {
                        goMyOrer();
                    }}
                    gray={true}
                    black={true}
                    text="주문내역조회"
                />
                <BasicBtn
                    onClick={() => {
                        goProduct();
                    }}
                    text="쇼핑계속하기"
                />
            </BtnWrap>
        </Warp>
    );
}

const Warp = styled.div`
    position: relative;
    width: calc(100vw * (1060 / 1920));
    margin: 0 auto;

    padding-top: calc(100vw * (50 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1060 / 1300));

        padding-top: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};

        padding-top: ${M(30)};
    }
`;
const Title = styled.h3`
    font-family: "Pop-EL";
    font-size: calc(100vw * (50 / 1920));

    margin-bottom: calc(100vw * (5 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (50 / 1300));

        margin-bottom: calc(100vw * (5 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-family: "Pop-R";
        font-size: ${M(20)};

        margin-bottom: ${M(10)};
    }
`;

const Desc = styled.p`
    font-family: "Noto-B";
    font-size: calc(100vw * (30 / 1920));

    margin-bottom: calc(100vw * (50 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (30 / 1300));

        margin-bottom: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};

        margin-bottom: ${M(30)};
    }
`;
const OrderNum = styled.p`
    display: flex;
    align-items: baseline;
    font-family: "Noto-R";
    font-size: calc(100vw * (20 / 1920));

    margin-bottom: calc(100vw * (15 / 1920));

    & span {
        font-family: "Noto-B";
        color: var(--main-color);

        padding: 0 calc(100vw * (2 / 1920));
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (20 / 1300));

        margin-bottom: calc(100vw * (15 / 1300));

        & span {
            padding: 0 calc(100vw * (2 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};

        margin-bottom: ${M(19)};

        & span {
            padding: 0 ${M(10)};
        }
    }
`;

const TableWrap = styled.div``;

const TabelTitle = styled.div`
    display: flex;
    align-items: center;

    padding: calc(100vw * (15 / 1920)) 0;

    border-top: 1px solid #000;
    border-bottom: 1px solid #dddddd;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (15 / 1300)) 0;
    }
`;

const TableName = styled.div`
    font: calc(100vw * (15 / 1920)) "Noto-M";
    text-align: center;

    width: calc(100vw * (510 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        width: calc(100vw * (510 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        font-size: ${M(14)};

        margin-bottom: ${M(10)};
    }
`;
const DivListBox = styled.div`
    display: flex;
    align-items: center;

    width: calc(100vw * (465 / 1920));

    padding-right: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (465 / 1300));

        padding-right: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        padding-right: ${M(10)};
    }
`;
const ImgWrap = styled.div`
    flex-shrink: 0;
    width: calc(100vw * (80 / 1920));
    height: calc(100vw * (80 / 1920));

    margin-right: calc(100vw * (18 / 1920));
    margin-bottom: calc(100vw * (9 / 1920));

    cursor: pointer;

    border-radius: 4px;
    border: solid 1px #ddd;
    background-color: #fafafa;

    overflow: hidden;

    /* ${({ bigImg }) => {
        return (
            bigImg &&
            `
        width: calc(100vw * (145 / 1920));
        height: calc(100vw * (145 / 1920));

        margin-right: calc(100vw * (30 / 1920));
        margin-bottom: 0;
        `
        );
    }} */

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (80 / 1300));
        height: calc(100vw * (80 / 1300));

        margin-right: calc(100vw * (18 / 1300));
        margin-bottom: calc(100vw * (9 / 1300));

        /* ${({ bigImg }) => {
            return (
                bigImg &&
                `
                    width: calc(100vw * (145 / 1300));
                    height: calc(100vw * (145 / 1300));

                    margin-right: calc(100vw * (30 / 1300));
                    margin-bottom: 0;
                `
            );
        }} */
    }

    @media screen and (max-width: 900px) {
        width: ${M(80)};
        height: ${M(80)};
        margin-right: ${M(18)};
        margin-bottom: 0;

        /* ${({ bigImg }) => {
            return (
                bigImg &&
                `
                    width:${M(95)};
                    height:${M(95)};

                    margin-right: ${M(15)};
                    `
            );
        }} */
    }
`;

const Img = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const TextWrap = styled.div`
    width: calc(100% - 100vw * (98 / 1920));

    /* ${({ bigImg }) => {
        return (
            bigImg &&
            `
        width: calc( 100% - 100vw * (145/ 1920));
        `
        );
    }} */

    @media screen and (max-width: 1300px) {
        width: calc(100% - 100vw * (98 / 1300));

        /* ${({ bigImg }) => {
            return (
                bigImg &&
                `
        width: calc( 100% - 100vw * (145/ 1300));
        `
            );
        }} */
    }

    @media screen and (max-width: 900px) {
        /* width: 100% - 100vw * ${M(465)}; */

        /* ${({ bigImg }) => {
            return (
                bigImg &&
                `
        // width: calc( 100% - 100vw * (145/ 1920));
        `
            );
        }} */
    }
`;

const TopWrap = styled.div`
    display: flex;
    align-items: center;

    padding-right: calc(100vw * (1 / 1920));

    @media screen and (max-width: 1300px) {
        padding-right: calc(100vw * (1 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding-right: 0;
    }
`;

const Name = styled.h3`
    font-family: "Pop-EB";
    font-size: calc(100vw * (14 / 1920));

    margin-bottom: calc(100vw * (6 / 1920));

    /* 한줄처리 */
    max-width: calc(100% - calc(100vw * (20 / 1920)));
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    margin-right: auto;
    cursor: pointer;

    ${({ thinText }) => {
        return (
            thinText &&
            `
            font-family: 'Pop-M';
        `
        );
    }}

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));

        margin-bottom: calc(100vw * (6 / 1300));

        /* 한줄처리 */
        max-width: calc(100% - calc(100vw * (20 / 1300)));
    }

    @media screen and (max-width: 900px) {
        line-height: 1;
        font-size: ${M(14)};
        margin-bottom: ${M(6)};
        max-width: ${M(90)};
    }
`;
const OptionWrap = styled.div`
    & p {
        text-align: left;
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(5)};
    }
`;
const Option = styled.p`
    font-size: calc(100vw * (13 / 1920));

    color: #aaaaaa;
    font-family: "Pop-M";

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
    }
`;

const UtilWrap = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const Slice = styled.span`
    font-size: ${M(13)};
    margin: 0 ${M(5)};
`;
const MbPriceWrap = styled.p`
    display: flex;
    align-items: baseline;
`;

const MbPrice = styled.span`
    font-size: ${M(13)};

    margin-right: ${M(2)};
`;
const MbWon = styled.span`
    font-size: ${M(11)};
`;
const MbNum = styled.p`
    font-size: ${M(13)};
`;

const TableDelivery = styled(TableName)`
    display: flex;
    align-items: baseline;
    width: calc(100vw * (150 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (150 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;

        padding-left: ${M(98)};
        text-align: left;

        margin-bottom: ${M(15)};
    }
`;

const TableNum = styled(TableName)`
    width: calc(100vw * (180 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (180 / 1300));
    }

    @media screen and (max-width: 900px) {
    }
`;

const TablePrice = styled(TableName)`
    width: calc(100vw * (220 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (220 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;

        margin-bottom: 0;
    }
`;

const PriceBigWrap = styled.div`
    text-align: center;

    padding: 0 calc(100vw * (10 / 1920));

    & p:last-child {
        font-size: calc(100vw * (13 / 1920));
        color: var(--main-color);
    }

    @media screen and (max-width: 1300px) {
        padding: 0 calc(100vw * (10 / 1300));

        & p:last-child {
            font-size: calc(100vw * (13 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        padding: 0;
        text-align: right;

        & p:last-child {
            font-size: ${M(13)};
        }
    }
`;
const PriceWrap = styled.p`
    text-align: center;

    display: flex;
    align-items: baseline;
    justify-content: center;

    margin-bottom: calc(100vw * (4 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (4 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(5)};

        justify-content: right;
    }
`;

const Price = styled.span`
    font-family: "Noto-B";
    font-size: calc(100vw * (15 / 1920));

    word-break: break-all;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(16)};
    }
`;

const Won = styled.span`
    font-family: "Noto-R";
    font-size: calc(100vw * (13 / 1920));

    margin-left: calc(100vw * (2 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));

        margin-left: calc(100vw * (2 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};

        margin-left: ${M(2)};
    }
`;

const DelText = styled.span`
    font-family: "Noto-R";
    font-size: calc(100vw * (15 / 1920));
    color: #8c8c8c;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        color: #222;
    }
`;

const DelWon = styled(DelText)`
    font-size: calc(100vw * (13 / 1920));

    margin-left: calc(100vw * (2 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));
        margin-left: calc(100vw * (2 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
        margin-left: ${M(2)};
    }
`;

const OrderListBigWrap = styled.ul`
    margin-bottom: calc(100vw * (45 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (45 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(30)};

        border-top: 1px solid #000;
    }
`;

const OrderListBox = styled.li`
    display: flex;
    align-items: center;
    border-bottom: 1px solid #dddddd;

    padding: calc(100vw * (20 / 1920)) 0;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        display: block;
        padding: ${M(20)} 0;
    }
`;

const Num = styled.p`
    font-size: calc(100vw * (14 / 1920));
    word-break: break-all;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;

const BtnWrap = styled.div`
    display: flex;
    justify-content: center;

    margin: calc(100vw * (40 / 1920)) 0 calc(100vw * (415 / 1920));

    & > p {
        width: calc(100vw * (200 / 1920));
    }

    & > p:first-child {
        margin-right: calc(100vw * (19 / 1920));
    }

    @media screen and (max-width: 1300px) {
        margin: calc(100vw * (40 / 1920)) 0 calc(100vw * (415 / 1300));

        & > p {
            width: calc(100vw * (200 / 1300));
        }

        & > p:first-child {
            margin-right: calc(100vw * (19 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        margin: ${M(40)} 0 ${M(100)};

        & > p {
            width: ${M(160)};
            padding: ${M(10)} 0;
            font-size: ${M(14)};
        }

        & > p:first-child {
            margin-right: ${M(20)};
        }
    }
`;
